export function keyboardNavigate(element: HTMLElement, elements: HTMLElement[] = []) {
  // keybord navigation
  let focusedItemIndex: number = 0;

  // handle window keydown event
  function focusFirstElement(event: KeyboardEvent) {
    // exit early if there are no elements
    if (elements.length === 0) return;

    // when the up / down arrow keys are pressed, it will set the focus to the first element
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      elements[0]?.focus();
      event.stopPropagation();
      event.preventDefault();
    }
  }

  // handle element list keydown event
  function handleKeydown(event: KeyboardEvent) {
    // exit early if there are no elements
    if (elements.length === 0) return;

    // UP AND DOWN KEY NAVIGATION TO MOVE THROUGH REPLIES
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      focusedItemIndex = Math.max(
        Math.min(focusedItemIndex + (event.code === "ArrowUp" ? -1 : 1), elements.length - 1),
        0
      );
      elements[focusedItemIndex].focus();
      elements[focusedItemIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      event.stopPropagation();
      event.preventDefault();
    }
  }

  window.addEventListener("keydown", focusFirstElement);
  element.addEventListener("keydown", handleKeydown);

  return {
    update(newElements: HTMLElement[]) {
      // filter out any null elements
      elements = newElements.filter(Boolean);
      focusedItemIndex = 0;
    },
    destroy() {
      window.removeEventListener("keydown", focusFirstElement);
      element.removeEventListener("keydown", handleKeydown);
    },
  };
}
